export function getNodeTemplateIds(nodes) {
    if (!nodes) {
        return [];
    }
    return nodes
        .filter((node) => node.nodeType === 'autoreply')
        .reduce((acc, template) => [
        ...acc,
        ...[template.payload.auto_reply_template_id].filter((t) => !acc.includes(t)),
    ], []);
}
